'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var universalAnalytics = require('@zillow/universal-analytics');
var shouldShowVideo = require('@zillow/should-show-video');
var homeDetailsFormatters = require('@zillow/home-details-formatters');
var gql = require('graphql-tag');

function _interopDefault (e) { return e && e.__esModule ? e['default'] : e; }

var React__default = /*#__PURE__*/_interopDefault(React);
var gql__default = /*#__PURE__*/_interopDefault(gql);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _jsxFileName = "/builds/zillow/npm/universal-analytics-react/src/contexts/UniversalAnalyticsContext.tsx",
    _jsxFileName2 = "/builds/zillow/npm/universal-analytics-react/src/contexts/UniversalAnalyticsContext.tsx",
    _this = undefined;
var UniversalAnalyticsContext = /*#__PURE__*/React.createContext({
  areRequiredDimensionsSet: false,
  resetRequiredCustomDimensions: function resetRequiredCustomDimensions() {}
});
var Consumer = UniversalAnalyticsContext.Consumer,
    Provider = UniversalAnalyticsContext.Provider;
var UniversalAnalyticsContextProvider = function UniversalAnalyticsContextProvider(_ref) {
  var _React$createElement;

  var children = _ref.children,
      requiredCustomDimensions = _ref.requiredCustomDimensions,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {
    shouldRequireCustomDimensions: false
  } : _ref$options;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      areRequiredDimensionsSet = _useState2[0],
      setAreRequiredDimensionsSet = _useState2[1];

  function resetRequiredCustomDimensions() {
    if (areRequiredDimensionsSet && requiredCustomDimensions) {
      var nullRequiredCustomDimensions = {};
      Object.keys(requiredCustomDimensions).forEach(function (cd) {
        nullRequiredCustomDimensions[cd] = null;
      });
      universalAnalytics.setdim(nullRequiredCustomDimensions);
    }

    setAreRequiredDimensionsSet(false);
  } // Must be in the useEffect so that SSR pages using this context will call setCustomDimensions
  // in the browser, NOT the server. setCustomDimensions is dependent on the browser
  // `window` to work, but will not error without one.


  React.useEffect(function () {
    if (!areRequiredDimensionsSet) {
      if (requiredCustomDimensions && Object.keys(requiredCustomDimensions).length > 0) {
        universalAnalytics.setdim(requiredCustomDimensions);
        setAreRequiredDimensionsSet(true);
      } else if (!options.shouldRequireCustomDimensions) {
        setAreRequiredDimensionsSet(true);
      }
    }
  }, [setAreRequiredDimensionsSet, requiredCustomDimensions]);
  return /*#__PURE__*/React__default.createElement(Provider, (_React$createElement = {
    value: {
      areRequiredDimensionsSet: areRequiredDimensionsSet,
      resetRequiredCustomDimensions: resetRequiredCustomDimensions
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, _React$createElement["__self"] = _this, _React$createElement["__source"] = {
    fileName: _jsxFileName2,
    lineNumber: 47,
    columnNumber: 9
  }, _React$createElement), children);
};
var UniversalAnalyticsContextConsumer = Consumer;

var _templateObject, _templateObject2;
/**
 * Set a custom dimension value on the object if it is a a non-null, non-empty string.
 * Else, leave undefined.
 *
 * @param customDims To set the value on
 * @param dimensionNumber
 * @param value of the dimension
 */

var setValueIfValid = function setValueIfValid(customDims, dimensionNumber, value) {
  if (value && value.length > 0) {
    // This is an explicit setter, allow param mutation:
    // eslint-disable-next-line no-param-reassign
    customDims["dimension" + dimensionNumber] = value;
  }
};
/**
 * Map GDP data to the required custom dimensions for a route that maps to a single property
 * @param property
 * @param abTests
 */

var getRequiredCustomDimsForProperty = function getRequiredCustomDimsForProperty(_ref) {
  var property = _ref.property,
      abTests = _ref.abTests;
  var currency = property.currency,
      featuredListingTypeDimension = property.featuredListingTypeDimension,
      hdpPropertyTypeDimension = property.hdpTypeDimension,
      isZillowOwned = property.isZillowOwned,
      listingTypeDimension = property.listingTypeDimension,
      price = property.price,
      propertyTypeDimension = property.propertyTypeDimension,
      standingOffer = property.standingOffer,
      zipcode = property.zipcode,
      zpid = property.zpid,
      zillowOfferMarket = property.zillowOfferMarket; // --- Hardcoded, non-nullable values

  var customDims = {
    /**
     * pageType
     * @source zillow-web https://gitlab.zgtools.net/zillow/legacy-zillow-web/zillow-web/-/blob/master/src/main/java/com/zillow/web/components/ownerview/OVRProxyComponent.java#L260
     */
    dimension66: 'HDP',

    /**
     * hdpStateDimension: this is always the owner view. aka viewType, aka OwnerOrPublic.
     * Other implementations:
     * - zillow-web: https://gitlab.zgtools.net/zillow/legacy-zillow-web/zillow-web/-/blob/master/src/main/java/com/zillow/web/components/ownerview/OVRProxyComponent.java#L242
     * - Android: https://gitlab.zgtools.net/zillow/android/libs/android-ui-zillow/-/blob/master/src/main/java/com/zillow/android/ui/base/mappable/home/HomeMapItem.java#L1319
     * - iOS: https://gitlab.zgtools.net/zillow/ios/apps/ZillowMap/-/blob/master/libs/libZillow/RECommonUI/RECommonUI/HomeDetails/Analytics/HDPAnalyticsWrapper.swift#L86
     */
    dimension80: 'Owner',

    /**
     * hdpVideoDimension
     * @source HDC: https://gitlab.zgtools.net/zillow/hdp/home-details-content/-/blob/master/packages/home-details-pageview-tracker/src/home-details-pageview-tracker.js#L317
     *
     * Other implementations:
     * - zillow-web: https://gitlab.zgtools.net/zillow/legacy-zillow-web/zillow-web/-/blob/master/src/main/java/com/zillow/web/components/homedetail/HomeDetailComponent.java#L838
     * - Android: https://gitlab.zgtools.net/zillow/android/libs/android-ui-zillow/-/blob/master/src/main/java/com/zillow/android/ui/base/mappable/home/HomeMapItem.java#L1320
     * - iOS: https://gitlab.zgtools.net/zillow/ios/apps/ZillowMap/-/blob/master/libs/libZillow/RECommonUI/RECommonUI/HomeDetails/Analytics/HDPAnalyticsWrapper.swift#L85
     */
    dimension81: shouldShowVideo.shouldShowVideo(property, abTests) ? 'Public Video' : 'No Video',
    // Standing offer eligibility
    dimension196: standingOffer !== null && standingOffer !== void 0 && standingOffer.isStandingOfferEligible ? 'SO-Eligible' : 'SO-Ineligible'
  }; // --- GDP values (nullable)

  setValueIfValid(customDims, 2, zpid === null || zpid === void 0 ? void 0 : zpid.toString());
  setValueIfValid(customDims, 6, zipcode);
  setValueIfValid(customDims, 9, propertyTypeDimension);
  /**
   * price dimension
   * @source HDC: https://gitlab.zgtools.net/zillow/hdp/home-details-content/-/blob/master/packages/home-details-pageview-tracker/src/home-details-pageview-tracker.js#L309
   */

  setValueIfValid(customDims, 10, homeDetailsFormatters.priceWithCurrency(currency)(price));
  setValueIfValid(customDims, 14, hdpPropertyTypeDimension);
  setValueIfValid(customDims, 15, listingTypeDimension);
  setValueIfValid(customDims, 24, featuredListingTypeDimension);
  setValueIfValid(customDims, 133, isZillowOwned ? 'Zillow Owned' : null);
  setValueIfValid(customDims, 145, zillowOfferMarket !== null && zillowOfferMarket !== void 0 && zillowOfferMarket.legacyName ? "Market:" + zillowOfferMarket.legacyName : null);
  return customDims;
}; // There is no ShouldShowVideoFragment.abTests, adding the treatment here.
// Should be done in RMX-16268

var REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS = {
  property: gql__default(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        fragment UARequiredPropertyDimensions_property on Property {\n            currency\n            featuredListingTypeDimension\n            hasPublicVideo\n            hdpTypeDimension\n            listingTypeDimension\n            price\n            propertyTypeDimension\n            standingOffer {\n                isStandingOfferEligible\n            }\n            zpid\n            isZillowOwned\n            zillowOfferMarket {\n                legacyName\n            }\n            ...ShouldShowVideo_property\n        }\n        ", "\n    "])), shouldShowVideo.ShouldShowVideoFragment.property),
  abTests: gql__default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        fragment UARequiredPropertyDimensions_abTests on ABTests {\n            ZO_HDP_HOUR_ONE_VIDEO: abTest(trial: \"ZO_HDP_HOUR_ONE_VIDEO\")\n        }\n    "])))
};

/**
 * Sends a display event (i.e. event after render) after required custom dimensions are set.
 * @param props of the event
 * @param options of the event
 */
var useTrackDisplayEvent = function useTrackDisplayEvent(props, options) {
  var _useContext = React.useContext(UniversalAnalyticsContext),
      areRequiredDimensionsSet = _useContext.areRequiredDimensionsSet;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      wasEventTracked = _useState2[0],
      setWasEventTracked = _useState2[1];

  React.useEffect(function () {
    var _ref = options !== null && options !== void 0 ? options : {},
        _ref$shouldSendEvent = _ref.shouldSendEvent,
        shouldSendEvent = _ref$shouldSendEvent === void 0 ? true : _ref$shouldSendEvent,
        trackDisplayOptions = _objectWithoutProperties(_ref, ["shouldSendEvent"]);

    if (areRequiredDimensionsSet && shouldSendEvent && !wasEventTracked) {
      universalAnalytics.track(props, trackDisplayOptions);
      setWasEventTracked(true);
    }
  }, [areRequiredDimensionsSet, props, options, setWasEventTracked, wasEventTracked]);
  return {
    wasEventTracked: wasEventTracked
  };
};
/**
 * Sends a page view event after required custom dimensions are set.
 * @param path The path portion of a URL. This value should start with a slash (/)
 * @param props of the event
 * @param options of the event
 */

var useTrackPageViewEvent = function useTrackPageViewEvent(path, props, options) {
  var _useContext2 = React.useContext(UniversalAnalyticsContext),
      areRequiredDimensionsSet = _useContext2.areRequiredDimensionsSet;

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      wasEventTracked = _useState4[0],
      setWasEventTracked = _useState4[1];

  React.useEffect(function () {
    var _ref2 = options !== null && options !== void 0 ? options : {},
        _ref2$shouldSendEvent = _ref2.shouldSendEvent,
        shouldSendEvent = _ref2$shouldSendEvent === void 0 ? true : _ref2$shouldSendEvent,
        trackOptions = _objectWithoutProperties(_ref2, ["shouldSendEvent"]);

    if (areRequiredDimensionsSet && shouldSendEvent && !wasEventTracked) {
      universalAnalytics.page(path, props, trackOptions);
      setWasEventTracked(true);
    }
  }, [areRequiredDimensionsSet, path, props, options, setWasEventTracked, wasEventTracked]);
  return {
    wasEventTracked: wasEventTracked
  };
};

exports.REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS = REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS;
exports.UniversalAnalyticsContext = UniversalAnalyticsContext;
exports.UniversalAnalyticsContextConsumer = UniversalAnalyticsContextConsumer;
exports.UniversalAnalyticsContextProvider = UniversalAnalyticsContextProvider;
exports.getRequiredCustomDimsForProperty = getRequiredCustomDimsForProperty;
exports.setValueIfValid = setValueIfValid;
exports.useTrackDisplayEvent = useTrackDisplayEvent;
exports.useTrackPageViewEvent = useTrackPageViewEvent;
